import { Box, Button, DialogTitle, Grid, styled } from "@mui/material";
import { LOCAL_CONSTANT } from "../Const";

//スタイル
const CancelButton = styled(Button)({
    backgroundColor: "#ffffff00",
    color: "#f00",
    border: "1px solid #f00",
});

export interface LocationTraffic5mcutAndMarketCutApprovalCheck {
    props: {
        requestType: string;
        errorFlag: string;
        handleModalClose: () => void;
    };
}

export const LocationTraffic5mcutAndMarketCutApprovalCheck: React.FC<LocationTraffic5mcutAndMarketCutApprovalCheck> = ({ props }) => {
    //文字列分割関数
    const breakedText = (text: string) => {
        return text.split("\n").map((line, key) => (
            <span key={key}>
                {line}
                <br />
            </span>
        ));
    };

    // エラーメッセージ生成関数
    const renderErrorMessages = (storeLabel: string | null, errorType: number) => {
        const hasTraffic5m = errorType === 1 || errorType === 3;
        const hasMarketCut = errorType === 2 || errorType === 3;

        return (
            <DialogTitle>
                {storeLabel && (
                    <>
                        {storeLabel}
                        <br />
                    </>
                )}
                {hasTraffic5m && (
                    <>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_APPROVAL}
                        {hasMarketCut && <br />}
                    </>
                )}
                {hasMarketCut && (
                    <>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_MARKETCUT_APPROVAL}
                    </>
                )}
            </DialogTitle>
        );
    };

    return (
        <Box>
            {/* requestType === "0" の処理 */}
            {props.requestType === "0" && (
                <>
                    {/* S&B以外 (1-3) */}
                    {(props.errorFlag === "1" || props.errorFlag === "2" || props.errorFlag === "3") &&
                        renderErrorMessages(null, parseInt(props.errorFlag))}

                    {/* B店 (4-6) */}
                    {(props.errorFlag === "4" || props.errorFlag === "5" || props.errorFlag === "6") &&
                        renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, parseInt(props.errorFlag) - 3)}

                    {/* S店 (7-9) */}
                    {(props.errorFlag === "7" || props.errorFlag === "8" || props.errorFlag === "9") &&
                        renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, parseInt(props.errorFlag) - 6)}

                    {/* B店 + S店の組み合わせ (10-18) */}
                    {props.errorFlag === "10" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 1)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 1)}
                        </>
                    )}
                    {props.errorFlag === "11" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 1)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 2)}
                        </>
                    )}
                    {props.errorFlag === "12" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 1)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 3)}
                        </>
                    )}
                    {props.errorFlag === "13" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 2)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 1)}
                        </>
                    )}
                    {props.errorFlag === "14" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 2)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 2)}
                        </>
                    )}
                    {props.errorFlag === "15" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 2)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 3)}
                        </>
                    )}
                    {props.errorFlag === "16" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 3)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 1)}
                        </>
                    )}
                    {props.errorFlag === "17" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 3)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 2)}
                        </>
                    )}
                    {props.errorFlag === "18" && (
                        <>
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B, 3)}
                            {renderErrorMessages(LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S, 3)}
                        </>
                    )}
                </>
            )}
                {props.requestType === "2" &&
                props.errorFlag === "1" && (
                    <DialogTitle>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_MARKETCUT}
                    </DialogTitle>
                )}
                {props.requestType === "2" &&
                    props.errorFlag === "2" && (
                        <DialogTitle>
                            {breakedText(
                                LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_FILE
                            )}
                        </DialogTitle>
                    )}
                {props.requestType === "2" &&
                props.errorFlag === "3" && (
                    <DialogTitle>
                        {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B}<br />
                        {breakedText(
                                LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_FILE
                            )}
                    </DialogTitle>
                )}
                {props.requestType === "2" &&
                    props.errorFlag === "4" && (
                        <DialogTitle>
                            {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S}<br />
                            {breakedText(
                                LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_FILE
                            )}
                        </DialogTitle>
                    )}
                {props.requestType === "2" &&
                    props.errorFlag === "5" && (
                        <>
                            <DialogTitle>
                                {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_B}<br />
                                {breakedText(
                                    LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_FILE
                                )}
                            </DialogTitle>
                            <DialogTitle>
                                {LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_SB_S}<br />
                                {breakedText(
                                    LOCAL_CONSTANT.ERROR_MESSAGE.ERROR_NO_TRAFFIC5MCUT_FILE
                                )}
                            </DialogTitle>
                        </>
                    )}

            <Box sx={{ margin: "30px" }}>
                <Grid container spacing={1} alignItems="center">
                    <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", justifyContent: "center" }}
                    >
                        <CancelButton onClick={props.handleModalClose}>
                            閉じる
                        </CancelButton>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};

export default LocationTraffic5mcutAndMarketCutApprovalCheck;
